import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import SEO from "@/data/seo.json";

const setMeta = (attr, key, content) => {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
};

const setCanonical = (href) => {
  let el = document.head.querySelector('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", "canonical");
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
};

export const pageSeo = (path) => SEO.pages[path];

export const useSeo = ({ title, description, image }, jsonLd) => {
  const { pathname } = useLocation();
  useEffect(() => {
    const url = `${SEO.siteUrl}${pathname === "/" ? "/" : pathname.replace(/\/$/, "")}`;
    document.title = title;
    setMeta("name", "description", description);
    setMeta("property", "og:title", title);
    setMeta("property", "og:description", description);
    setMeta("property", "og:url", url);
    if (image) setMeta("property", "og:image", image.startsWith("/") ? `${SEO.siteUrl}${image}` : image);
    else document.head.querySelector('meta[property="og:image"]')?.remove();
    setCanonical(url);
    document.getElementById("page-jsonld")?.remove();
    if (jsonLd) {
      const s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "page-jsonld";
      s.text = JSON.stringify(jsonLd);
      document.head.appendChild(s);
    }
  }, [title, description, image, pathname, jsonLd]);
};
